import type { GinStepDocumentRequest } from '../../features/api/client-api';
import { requirementFromPersonalRequest } from '../../features/api/program-documents-api';
import type { DashboardApplicationDocumentRequest } from './document-requests-widget';

export const dashboardApplicationDocumentRequestFromPersonalRequest = (
  request: GinStepDocumentRequest,
): DashboardApplicationDocumentRequest => {
  const programRequirement = requirementFromPersonalRequest(request);

  return {
    source: 'application',
    id: programRequirement.id,
    applicationId: request.program_id,
    documentName: request.document_name,
    applicationName: request.application_name,
    kind: programRequirement.kind,
    programRequirement,
  };
};

export const deduplicateDashboardApplicationDocumentRequests = (
  requests: readonly DashboardApplicationDocumentRequest[],
) =>
  Array.from(
    new Map(
      requests.map((request) => [
        `${request.applicationId}:${request.id}`,
        request,
      ]),
    ).values(),
  );
